import {AxiosError, AxiosResponse} from "axios";
import {injectable} from "inversify";

import "@/extensions/date.extensions";
import {ApiService} from "@/services/apiService";
import {IChangePasswordRequest} from "@/types/requests/changePasswordRequest";
import {IUserService} from "@/injection/interfaces";
import {SucceededOrNotResponse} from "@/types/responses/succeededOrNotResponse";
import {IChangeEmailRequest} from "@/types/requests/changeEmailRequest";
import {IResetMemberPasswordRequest} from "@/types/requests";

@injectable()
export class UserService extends ApiService implements IUserService {
  public async changeEmail(request: IChangeEmailRequest): Promise<SucceededOrNotResponse> {
    const response = await this
      ._httpClient
      .put<IChangeEmailRequest, AxiosResponse<SucceededOrNotResponse>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/users/me/change-email`,
        request)
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    const succeededOrNotResponse = response.data as SucceededOrNotResponse
    return new SucceededOrNotResponse(succeededOrNotResponse.succeeded, succeededOrNotResponse.errors)
  }

  public async changePassword(request: IChangePasswordRequest): Promise<SucceededOrNotResponse> {
    const response = await this
      ._httpClient
      .put<IChangePasswordRequest, AxiosResponse<SucceededOrNotResponse>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/users/me/change-password`,
        request)
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    const succeededOrNotResponse = response.data as SucceededOrNotResponse
    return new SucceededOrNotResponse(succeededOrNotResponse.succeeded, succeededOrNotResponse.errors)
  }

  public async resetMemberPassword(organizationId: string, memberId: string, request: IResetMemberPasswordRequest): Promise<SucceededOrNotResponse> {
    const response = await this
        ._httpClient
        .put<IResetMemberPasswordRequest, AxiosResponse<SucceededOrNotResponse>>(
            `${process.env.VUE_APP_API_BASE_URL}/api/organizations/${organizationId}/members/${memberId}/reset-password`,
            request)
        .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
          return error.response as AxiosResponse<SucceededOrNotResponse>;
        });
    const succeededOrNotResponse = response.data as SucceededOrNotResponse
    return new SucceededOrNotResponse(succeededOrNotResponse.succeeded, succeededOrNotResponse.errors)
  }


  public async resendInvite(userId: string): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient
      .post<AxiosResponse<SucceededOrNotResponse>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/users/${userId.toString()}/resend-invite`,
        this.buildEmptyBody(),
        this.headersWithJsonContentType())
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    const succeededOrNotResponse = response.data as SucceededOrNotResponse
    return new SucceededOrNotResponse(succeededOrNotResponse.succeeded, succeededOrNotResponse.errors)
  }
}